<template>
  <modal-window :main-width="9">
    <h2>Select Category</h2>
    <p>Select a category for this template or leave empty for uncategorized.</p>

    <div class="form-group">
      <label>Category</label>
      <select class="form-control" v-model="selectedCategoryGuid">
        <option :value="null">-- No Category --</option>
        <option v-for="cat in categories" :key="cat.guid" :value="cat.guid">
          {{ cat.name }}
        </option>
      </select>
    </div>

    <template #sidebar>
      <div class="d-flex flex-column justify-content-end h-100">
        <div class="label mb-2">
          <button class="btn btn-block btn-sm btn-info" @click="close">
            <i class="far fa-times"></i>
            Cancel
          </button>
        </div>
        <div class="label mb-2">
          <button class="btn btn-block btn-sm btn-success" @click="saveAndClose">
            <i class="far fa-save"></i>
            Save and close
          </button>
        </div>
      </div>
    </template>
  </modal-window>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { BoardItemDto, TemplateCategoryDto } from '@/apiclient/apiclient_generated';
import { templateCategoryClient } from '@/apiclient/opsboard-api';
import { GlobalHelper } from '@/helpers/global-helper';
import ModalWindow from '@/components/ModalWindow.vue';

@Component({
  components: { ModalWindow }
})
export default class TemplateCategorySelectModal extends Vue {
  @Prop({ default: null }) template!: BoardItemDto | null;
  @Prop({ required: true }) categories!: TemplateCategoryDto[];

  private selectedCategoryGuid: string | null = null;

  mounted() {
    if (this.template) {
      this.selectedCategoryGuid = this.template.templateCategoryGuid || null;
    }
  }

  @Watch('template')
  onTemplateChange(val: BoardItemDto | null) {
    if (val) {
      this.selectedCategoryGuid = val.templateCategoryGuid || null;
    }
  }

  close() {
    this.$root.$bvModal.hide('templateCategoryModal');
  }

  async saveAndClose() {
    if (!this.template) return;

    try {
      await templateCategoryClient.setTemplateCategory(this.template.id!, this.selectedCategoryGuid || undefined);
      GlobalHelper.NotifySuccess('Template category updated');
      this.close();
    } catch (error) {
      GlobalHelper.NotifyError('Failed to update template category');
    }
  }
}
</script>
